import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, message } from 'antd';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import OrderQuery from './pages/OrderQuery';
import Login from './pages/Login';
import Register from './pages/Register';
import MyOrders from './pages/MyOrders';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminOrders from './pages/admin/Orders';
import AdminCards from './pages/admin/Cards';
import { userAPI } from './utils/api';

const { Content } = Layout;

// 配置全局message
message.config({
  top: 60,
  duration: 3,
  maxCount: 3,
});

// 受保护的路由组件
const PrivateRoute = ({ children }) => {
  const user = userAPI.getCurrentUser();
  return user ? children : <Navigate to="/login" />;
};

// 管理员路由组件
const AdminRoute = ({ children }) => {
  const user = userAPI.getCurrentUser();
  return user && user.role === 'admin' ? children : <Navigate to="/" />;
};

function App() {
  const [user, setUser] = useState(userAPI.getCurrentUser());

  useEffect(() => {
    const handleStorageChange = () => {
      setUser(userAPI.getCurrentUser());
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    userAPI.logout();
    setUser(null);
    message.success('退出登录成功');
  };

  return (
    <Layout className="app-container">
      <Header user={user} onLogout={handleLogout} />
      <Content className="content-wrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/order-query" element={<OrderQuery />} />
          <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
          <Route path="/register" element={<Register />} />
          <Route path="/my-orders" element={
            <PrivateRoute>
              <MyOrders />
            </PrivateRoute>
          } />
          <Route path="/admin" element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
          <Route path="/admin/products" element={
            <AdminRoute>
              <AdminProducts />
            </AdminRoute>
          } />
          <Route path="/admin/orders" element={
            <AdminRoute>
              <AdminOrders />
            </AdminRoute>
          } />
          <Route path="/admin/cards/:productId" element={
            <AdminRoute>
              <AdminCards />
            </AdminRoute>
          } />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Content>
      <Footer />
    </Layout>
  );
}

export default App;
